import { Component, OnInit } from "@angular/core";
import { CookieService } from 'ngx-cookie-service';
import {ApiService} from "../../shared/services/api.service";

declare interface RouteInfo {
  path: string;
  title: string;
  rtlTitle: string;
  icon: string;
  class: string;
  role: any;
  // children: any;
}
export const ROUTES: RouteInfo[] = [
  {
    path: "/manager/dashboard",
    title: "Dashboard",
    rtlTitle: "لوحة القيادة",
    icon: "icon-chart-pie-36",
    class: "",
    role: ['CharityManager']
    // children: []
  },
  {
    path: "/manager/Charities",
    title: "Charities",
    rtlTitle: "لوحة القيادة",
    icon: "icon-chart-pie-36",
    class: "",
    role: ['Administrator','Admin']
    // children: [{title: 'منوی جدید', path: '/22/dashboard'}, {title: ' منوی جدید دیگر', path: '/test'}]
  },
  {
    path: "/manager/users",
    title: "Users",
    rtlTitle: "لوحة القيادة",
    icon: "icon-chart-pie-36",
    class: "",
    role: ['Administrator', 'Admin']
    // children: [{title: 'Categories', path: '/manager/training'},
    //   {title: 'Posts', path: 'posts'}]
  },
  {
    path: "/manager/setting",
    title: "Settings",
    rtlTitle: "لوحة القيادة",
    icon: "icon-chart-pie-36",
    class: "",
    role: ['Administrator', 'Admin']
    // children: [{title: 'Categories', path: '/manager/training'},
    //   {title: 'Posts', path: 'posts'}]
  },
];

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"]
})
export class SidebarComponent implements OnInit {
  menuItems: any[];
  test: Date = new Date();
  flag: any;
  constructor(public apiService: ApiService,
        private cookieService: CookieService,) {}

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
  }
  isMobileMenu() {
    if (window.innerWidth > 991) {
      return false;
    }
    return true;
  }
  // openSbmenu(i){
  //   var x = document.querySelectorAll(".show");
  //   for(let i =0 ; i<x.length; i++){
  //     x[i].classList.remove('show')
  //   }
  //   document.getElementById(i).classList.add('show');

  // }
  reload(){
    window.location.reload();
  }

  // $sideHeaderNav.on('click', 'li a, li .menu-expand', function (e) {
  //   var $this = $(this);
  //   if ($this.parent('li').hasClass('has-sub-menu') || ($this.attr('href') === '#' || $this.hasClass('menu-expand'))) {
  //     e.preventDefault();
  //     if ($this.siblings('ul:visible').length) {
  //       $this.parent('li').removeClass('active').children('ul').slideUp().siblings('a').find('.menu-expand i').removeClass('zmdi-chevron-up').addClass('zmdi-chevron-down');
  //       $this.parent('li').siblings('li').removeClass('active').find('ul:visible').slideUp().siblings('a').find('.menu-expand i').removeClass('zmdi-chevron-up').addClass('zmdi-chevron-down');
  //     } else {
  //       $this.parent('li').addClass('active').children('ul').slideDown().siblings('a').find('.menu-expand i').removeClass('zmdi-chevron-down').addClass('zmdi-chevron-up');
  //       $this.parent('li').siblings('li').removeClass('active').find('ul:visible').slideUp().siblings('a').find('.menu-expand i').removeClass('zmdi-chevron-up').addClass('zmdi-chevron-down');
  //     }
  //   }
  // });

  isAuthorized(role) {
    this.flag = false;
    const rolesArray = JSON.parse(this.cookieService.get('currentUserRoles'));
    for (let i = 0; i < rolesArray.length; i++) {
      if (role.includes(rolesArray[i])) {
        this.flag = true;
        break;
      }
    }
    return this.flag;
  }



}
